import { cropImage, getRgb, setRgb } from './image.js';
export const OwlHsvRanges = {
    blackText: { low: [0, 0, 0], high: [0, 255, 221] },
    redText: { low: [0, 34, 170], high: [178, 255, 255] },
    /** Red-on-white palette used by the Owl item title and total-count value. */
    headerRedText: { low: [0, 16, 255], high: [0, 255, 255] },
};
export function rgbToOpenCvHsv([r, g, b]) {
    const rn = r / 255, gn = g / 255, bn = b / 255;
    const max = Math.max(rn, gn, bn), min = Math.min(rn, gn, bn), delta = max - min;
    let hDegrees = 0;
    if (delta !== 0) {
        if (max === rn)
            hDegrees = 60 * (((gn - bn) / delta) % 6);
        else if (max === gn)
            hDegrees = 60 * ((bn - rn) / delta + 2);
        else
            hDegrees = 60 * ((rn - gn) / delta + 4);
    }
    if (hDegrees < 0)
        hDegrees += 360;
    return [Math.min(179, Math.round(hDegrees / 2)), max === 0 ? 0 : Math.round((delta / max) * 255), Math.round(max * 255)];
}
export function hsvInRange(hsv, range) {
    return hsv[0] >= range.low[0] && hsv[0] <= range.high[0]
        && hsv[1] >= range.low[1] && hsv[1] <= range.high[1]
        && hsv[2] >= range.low[2] && hsv[2] <= range.high[2];
}
export function rgbInHsvRange(rgb, range) { return hsvInRange(rgbToOpenCvHsv(rgb), range); }
export function hasColorInRange(source, rect, range) {
    const crop = cropImage(source, rect);
    for (let y = 0; y < crop.height; y++)
        for (let x = 0; x < crop.width; x++)
            if (rgbInHsvRange(getRgb(crop, x, y), range))
                return true;
    return false;
}
export function filterColorInPlace(image, range, fill = [255, 255, 255]) {
    let found = false;
    for (let y = 0; y < image.height; y++)
        for (let x = 0; x < image.width; x++) {
            if (rgbInHsvRange(getRgb(image, x, y), range))
                found = true;
            else
                setRgb(image, x, y, fill);
        }
    return found;
}
//# sourceMappingURL=color.js.map